import styled, { css } from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';

import { BenchObjectTableLastCell } from 'components/benchObject/BenchObjectTable/ui';

const ButtonSkeleton = styled(Skeleton)`
  flex-shrink: 0;
  width: 118px;
  height: var(--quadruple-unit);
`;

const Prices = styled(Horizontal)<{ $column: boolean }>`
  align-items: flex-end;
  ${({ $column }) =>
    $column
      ? css`
          flex-direction: column-reverse;
        `
      : ''}
`;
const PriceSkeleton = styled(Skeleton)`
  width: 60px;
  height: var(--triple-unit);
`;
const ExponentPriceSkeleton = styled(Skeleton)`
  width: 72px;
  height: 14px;
`;

export const LastCellSkeleton = () => {
  const {
    walletPreferences: { onlyShowFiatCurrency },
  } = useCurrentUserContext();
  const { up: laptopOrabove } = useScreenSize('laptop');
  return (
    <BenchObjectTableLastCell>
      <Prices gap={0.5} $column={!laptopOrabove}>
        {!onlyShowFiatCurrency && <ExponentPriceSkeleton />}
        <PriceSkeleton />
      </Prices>
      {laptopOrabove && (
        <Horizontal>
          <ButtonSkeleton />
        </Horizontal>
      )}
    </BenchObjectTableLastCell>
  );
};
